import { Box, Typography } from "@mui/material";

const Section3 = () => {
	return (
		<Box className="div3" sx={{ px: 10, height: "100vh", flexDirection: "column", display: "flex", justifyContent: "center", alignItems: "flex-end" }}>
			<Typography component="h2"
				sx={{ fontSize: "4rem", fontWeight: 700, maxWidth: 800, lineHeight: 1.3, }}
				className="title">
				<p className="stroke">INDUSTRY </p>
				COURSE</Typography>
			<Typography sx={{ mt: 4, fontSize: "1.2rem", maxWidth: 800 }} component="p">Drone Destination, together with its sister company, Hubblefly Technologies, a DGCA-approved manufacturer, is a DGCA-authorized Remote Pilot Training Organization that has developed an integrated drone eco-system built around drone manufacturing, certified training, services, and rent a drone.</Typography>

		</Box>
	)
}

export default Section3;